/* eslint-disable @typescript-eslint/no-explicit-any */
export class UnitRatesMapper {
  mapArrayToModelDomain = (unitRates: any[]) =>
    unitRates.map((unitRate: any) => ({
      from: {
        id: unitRate.fromUnit.id,
        currency: unitRate.fromUnit.currency,
        term: unitRate.fromUnit.term,
        realYear: unitRate.fromUnit.realYear,
      },
      to: {
        id: unitRate.toUnit.id,
        currency: unitRate.toUnit.currency,
        term: unitRate.toUnit.term,
        realYear: unitRate.toUnit.realYear,
      },
      ratesByYear: unitRate.byYearRates,
    }));
}
